import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { catchError } from 'rxjs/internal/operators/catchError';
import { Logger } from '../Logger.service';
import { SrdUser } from '../models/srd-user';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private user: SrdUser;
  dialog: boolean = false;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(private http: HttpClient, private logger: Logger) {}

  /** Verify user from the server */
  verifyUser(userEmail: string, userPassword: string): Observable<boolean> {
    console.log('LoginService: User EMail: ' + userEmail);
    return this.http
      // .post<boolean>(
      //   'http://localhost:8080/api/v1/verifyLogin?userEmail=' +
      //     userEmail +
      //     '&userPassword=' +
      //     btoa(userPassword),
        .post<boolean>(
          'https://srd-soft-tech.azurewebsites.net/api/v1/verifyLogin?userEmail=' +
            userEmail +
            '&userPassword=' + btoa(userPassword),
        this.httpOptions
      )
      .pipe(catchError(this.handleError<boolean>('verifyUser: ', false)));
  }

  findUserByEmail(userEmail: string): Observable<SrdUser> {
    return (
      this.http
        .post<SrdUser>(
          'https://srd-soft-tech.azurewebsites.net/api/v1/verifyLogin/' +
            userEmail,
          this.httpOptions
        )
        // .post<SrdUser>(
        //   'http://localhost:8080/api/v1/verifyLogin/' + userEmail,
        //   this.httpOptions
        // )
        .pipe(catchError(this.handleError<SrdUser>('User already exists!')))
    );
  }

  resetPassword(userEmail: string, userPassword: string): Observable<string> {
    return (
      this.http
        // .put<string>(
        //   'http://localhost:8080/api/v1/updatePassword?userEmail=' +
        //     userEmail +
        //     '&userPassword=' +
        //     btoa(userPassword),
        //   this.httpOptions
        // )
        .put<string>(
          'https://srd-soft-tech.azurewebsites.net/api/v1/updatePassword?userEmail=' +
            userEmail +
            '&userPassword=' +
            btoa(userPassword),
          this.httpOptions
        )
        .pipe(
          catchError(
            this.handleError<string>(
              'verifyUser: ',
              'Password not updated for the user: ' + userEmail
            )
          )
        )
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
